// import './util/parseFloat';

import React from 'react';
import { ClearCacheProvider, useClearCacheCtx } from 'react-clear-cache';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';

import ConnectedLoader from 'components/ConnectedLoader';

import { store } from 'appRedux/store';
import Root from 'config/Root';
import * as serviceWorker from 'registerServiceWorker';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import 'assets/scss/global.css';

const App = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCacheCtx();

  React.useEffect(() => {
    if (!isLatestVersion) emptyCacheStorage();
    //   eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLatestVersion]);

  return (
    <Provider store={store}>
      <ConnectedLoader />
      <AppContainer>
        <Root />
      </AppContainer>
    </Provider>
  );
};

serviceWorker.unregister();

ReactDOM.render(
  <ClearCacheProvider>
    <App />
  </ClearCacheProvider>,
  document.getElementById('root'),
);
